// extracted by mini-css-extract-plugin
export default {"dialogContent":"dialog-module__dialogContent___kG4rg","heading":"dialog-module__heading___UILKU","button":"dialog-module__button___CagYw"};